export function getErrorProps(err) {
  const { message, stack, status, cause, constructor, ...customProps } = err;
  return { type: err.constructor.name, message, stack, status, cause, constructor, customProps };
}

export function serializeError(err, depth = 1) {
  if (depth > 3) {
    return '[omitted]';
  }
  if (!(err instanceof Error)) return err;

  const { type, message, status, stack, cause, customProps } = getErrorProps(err);
  const optionalFields = status ? { status } : {}; // if field not there then don't log it as opposed to log with undefined value
  const serialized = {
    // the order of props here will define the output in development environment. NR displays them in alphabetical order
    type,
    message,
    ...optionalFields,
    ...customProps,
    stack,
  };
  if (cause) {
    if (Array.isArray(cause)) {
      cause.forEach((e, index) => {
        // workaround to NR not handling arrays well - it stringifies them with no formatting
        serialized[`cause[${index}]`] = serializeError(e, depth + 1);
      });
    } else if (cause instanceof Error) {
      serialized.cause = serializeError(cause, depth + 1);
    } else {
      serialized.cause = cause; // handle other types gracefully
    }
  }
  return serialized;
}

export const loggerLevels = { trace: 10, debug: 20, info: 30, warn: 40, error: 50 };
export const loggerMethods = Object.keys(loggerLevels);
